// extracted by mini-css-extract-plugin
export default {"modal":"CQ-z","sharingIconsV2":"DQ-z","notificationBox":"EQ-z","checkMark":"FQ-z","textFrame":"GQ-z"};